export const SNACKBAR_ID = 'add-to-cart-prompt';
export const SCROLL_BEHAVIOR = 'smooth';
export const COMBO_QUERY_PARAM = 'combo';
export const REDIRECT_FROM = 'rf';
export const COUPON_APPLIED_MSG =
  'Coupon has been applied automatically to bag.';
export const GOTO_BAG_SHOWN = 'goto_bag_shown';
export const WISHLIST_CTA = 'add to wishlist';
export const STICKY_PRICE_SUBTEXT = 'Incl. All Taxes';

export const PAGE_SOURCE_PARAM = 'pagesource';
export const PRODUCT_WIDGET_VALUE = 'productwidget';
export const PRODUCT_WIDGET_LABEL = 'productWidget';
export const INTERACTION_LOCATION_PDP = 'productDetailPage';
export const PDP_PATH_PATTERN = '/p/';
export const SITE_NAVIGATION_PARAM = 'site_navigation';
export const SITE_SUB_NAVIGATION_PARAM = 'site_sub_navigation';
